import variables from 'styles/_variables.scss'
import chroma from 'chroma-js'

const isDark = color => {
  return chroma(color).get('lab.l') < 70
}

export const eventStyleGetter = event => {
  let backgroundColor
  let color = 'black'

  switch (event.type) {
    case 'bid':
    case 'followup':
      backgroundColor = event.status.color || event.status.category.color
      color = isDark(backgroundColor) ? 'white' : 'black'
      break
    case 'lead':
      backgroundColor = variables.calendarLead
      break
    case 'task':
      if (event.task.dateCompleted) {
        backgroundColor = variables.calendarCompletedTask
        color = 'white'
      } else {
        backgroundColor = variables.calendarTask
      }
      break
    case 'event':
      backgroundColor = variables.calendarEvent
      break
  }

  const style = {
    backgroundColor,
    color
  }

  return {
    style: style
  }
}
